import React, { FC, useState } from 'react';
import { Button, TextInput } from 'flowbite-react';
import { HiPhone } from 'react-icons/hi';
import { CardContainer } from '../../../../layout';
import { telegramSendCode, telegramSignIn } from '../../../../services';
import { useGlobal } from '../../../../hooks/useGlobal';

interface TelegramLoginFormProps {
  deviceId: string;
  onSuccess?: () => void;
}

export const TelegramLoginForm: FC<TelegramLoginFormProps> = ({
  deviceId,
  onSuccess,
}) => {
  const { showAlert } = useGlobal();
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const handleSendCode = async () => {
    const confirmPhone = await showAlert({
      text: `${phoneNumber} numarasına doğrulama kodu gönderilecek`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Gönder',
      cancelButtonText: 'İptal',
    });

    if (!confirmPhone.isConfirmed) {
      return;
    }

    setLoading(true);

    try {
      const response = await telegramSendCode(deviceId, { phoneNumber });

      if (!response?.data?.phoneCodeHash) {
        throw new Error('phoneCodeHash bulunamadı');
      }

      const phoneCodeHash = response.data.phoneCodeHash;

      const { value: phoneCode, isConfirmed } = await showAlert({
        title: 'Doğrulama Kodu',
        input: 'text',
        inputPlaceholder: '12345',
        showCancelButton: true,
        confirmButtonText: 'Doğrula',
        cancelButtonText: 'İptal',
        inputValidator: (value) => {
          if (!value || value.trim() === '') {
            return 'Doğrulama kodu boş olamaz!';
          }
        },
      });

      if (!isConfirmed || !phoneCode) {
        return;
      }

      await telegramSignIn(deviceId, {
        phoneNumber,
        phoneCode: phoneCode.trim(),
        phoneCodeHash,
      });

      await showAlert({
        text: 'Telegram girişi başarıyla tamamlandı!',
        icon: 'success',
      });

      setPhoneNumber('');
      if (onSuccess) {
        onSuccess();
      }
    } catch (error: any) {
      console.error('Error in Telegram login process:', error);
      await showAlert({
        title: 'Hata',
        text: error.message || 'Telegram girişi sırasında bir hata oluştu.',
        icon: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <CardContainer title="Telegram Girişi">
      <div className="space-y-4">
        <TextInput
          id="phoneNumber"
          type="tel"
          icon={HiPhone}
          placeholder="905551234567"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          disabled={loading}
        />

        <Button
          type="button"
          color="blue"
          isProcessing={loading}
          disabled={loading || phoneNumber.trim() === ''}
          onClick={handleSendCode}
          className="w-full"
        >
          Telegram Girişi Yap
        </Button>
      </div>
    </CardContainer>
  );
};
